import { render, staticRenderFns } from "./carDetail.vue?vue&type=template&id=2401fb74&scoped=true"
import script from "./carDetail.vue?vue&type=script&lang=js"
export * from "./carDetail.vue?vue&type=script&lang=js"
import style0 from "./carDetail.vue?vue&type=style&index=0&id=2401fb74&prod&lang=scss&scoped=true"
import style1 from "./carDetail.vue?vue&type=style&index=1&id=2401fb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401fb74",
  null
  
)

export default component.exports